module.exports = "<div class=\"d-flex align-items-center\" ng-class=\"{accepted: $ctrl.value}\"><span class=no>NO</span><div><input type=checkbox id={{$ctrl.id}} ng-attr-name={{$ctrl.name}} ng-change=$ctrl.onChange() class=slider-toggle ng-model=$ctrl.value /> <label class=slider-viewport for={{$ctrl.id}}><div class=slider><div class=slider-button>&nbsp;</div><div class=\"slider-content left\"><span></span></div><div class=\"slider-content right\"><span></span></div></div></label></div><span class=yes>YES</span></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-switch/gmc-switch.component.html
// module id = 839
// module chunks = 31